import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Container, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import Cover from "./Cover";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../../containers/actions/types";
import { fetchTeamAssociates } from "../../../../containers/actions/common/teamMemberAction";
import { useDispatch } from "react-redux";
const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "2em",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "1em",
  },
  subtitle: {
    marginTop: "10px",
    fontSize: "14px",
    fontWeight: 500,
  },
  values: {
    fontSize: "14px",
    fontWeight: 400,
  },
  emailBox: {
    marginTop: "5px",
    marginBottom: "1em",
    paddingLeft: "10px",
    padding: "5px",
    width: "100%",
    backgroundColor: "#f1f1f1",
    border: "2px solid black",
    borderRadius: "4px",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
}));

export default function ProfileChangesSaved({
  setProfileChangesSaved,
  user,
  setViewDetailsDrawer,
  handleRefresh,
  selectedRole,
  reqObj,
}) {
  const classes = useStyles();
  const dispatch = useDispatch()

  const handleOk = () => {
    setProfileChangesSaved(false);
    setViewDetailsDrawer(false);
    handleRefresh();
    if (selectedRole) {
      dispatch({
        type: FETCH_TEAM_ASSOCIATES_LOADING,
        payload: true,
      });
      dispatch(
        fetchTeamAssociates({
          departmentID: selectedRole.departmentID,
          collaborator_role_id: selectedRole.collaborator_role_id,
          searchString: "all",
          status: "Active",
        })
      );
    }
  };
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Cover
        profilePic={user?.profile_pic}
        handleRefresh={handleRefresh}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
      />
      <Container
        style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography
          className={classes.heading}
          style={{ display: "flex", fontWeight: 600 }}
          gutterBottom
        >
          Profile changes saved
          <CheckCircleIcon style={{ color: "green", marginLeft: "10px" }} />
        </Typography>

        {reqObj.full_name && (
          <>
            <Typography className={classes.subtitle}>Full name</Typography>
            <Typography className={classes.values}>
              {reqObj?.full_name || user?.full_name}
            </Typography>
          </>
        )}

        {reqObj.email_address && (
          <>
            <Typography className={classes.subtitle}>Email</Typography>
            <Typography className={classes.values}>
              {user?.email_address || ""}
            </Typography>
            {reqObj?.email_address && (
              <Box className={classes.emailBox}>
                <Typography className={classes.values}>
                  The email will change to {reqObj.email_address} after
                  confirmation
                </Typography>
              </Box>
            )}
          </>
        )}
        {reqObj.phone_number && (
          <>
            <Typography className={classes.subtitle}>Phone</Typography>
            <Typography className={classes.values}>
              {reqObj?.phone_number || user?.phone_number}
            </Typography>
          </>
        )}

        {reqObj.country && (
          <>
            <Typography className={classes.subtitle}>
              Country of Residence
            </Typography>
            <Typography className={classes.values}>
              {reqObj?.country || user?.country}
            </Typography>
          </>
        )}
        {reqObj?.location && (
          <>
             <Typography className={classes.subtitle}>
             Location(for time zone purpose)
            </Typography>
            <Typography className={classes.values}>
              {reqObj?.location || user?.location }
            </Typography>
                      </>
        )}

        {reqObj?.role && (
          <>
            <Typography className={classes.subtitle}>
              Department - Role
            </Typography>
            <Typography className={classes.values}>
              {reqObj?.role
                ? reqObj.role
                : user?.department_name && user?.role_name
                  ? `${user.department_name} - ${user.role_name}`
                  : ""}
            </Typography>
          </>
        )}
        <Box className={classes.buttonContainer}>
          <Button
            onClick={handleOk}
            // onClick={() => setProfileChangesSaved(false)}
            size="small"
            className={classes.okButton}
            style={{
              textTransform: "none",
              backgroundColor: "#286acf",
              color: "#fff",
            }}
          >
            Ok
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
